import Alert, { AlertProps } from 'antd/lib/alert';
import React from 'react';
import styled from 'styled-components';
import { Flex } from '@ui-library/misc';
import theme from '@css/theme';

const AlertMessageStyled = styled(Alert)`
  background-color: #ffffff !important;

  svg {
    ${(props) => props.type === 'error' && 'fill:#ff4d4f'};
    ${(props) => props.type === 'success' && `fill: ${theme.color.success}`};
  }
`;

export interface AlertMessageProps extends AlertProps {
  action?: React.ReactNode;
}

export default ({ message, action, ...props }: AlertMessageProps) => (
  <AlertMessageStyled
    message={
      <Flex alignItems="center">
        <span>{message}</span>
        {action && <div style={{ marginLeft: 'auto' }}>{action}</div>}
      </Flex>
    }
    showIcon
    {...props}
    data-testid="alertMessage"
  />
);
